import { admissionSemesterOptions } from "@/src/constants/documentPreparationPopUpConsts";

export { admissionSemesterOptions };

export const ADMISSION_SEMESTER_LABELS = admissionSemesterOptions.map(({ label }) => label);

const ADMISSION_SEMESTER_ALIASES = admissionSemesterOptions.reduce<Record<string, string>>((aliases, { value, label }) => {
  aliases[value.toLowerCase()] = label;
  aliases[label.toLowerCase()] = label;
  aliases[label.replace(/ Semester$/i, " semester").toLowerCase()] = label;
  return aliases;
}, {});

export const normalizeAdmissionSemesterValue = (value?: unknown): string => {
  if (value == null) return "";
  const trimmed = String(value).trim();
  if (!trimmed) return "";

  if (admissionSemesterOptions.some(({ label }) => label === trimmed)) {
    return trimmed;
  }

  return ADMISSION_SEMESTER_ALIASES[trimmed.toLowerCase()] ?? trimmed;
};
